import cn from 'classnames';
import parse from 'html-react-parser';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import React, { FC } from 'react';

import { LocalAssets } from '@/shared/api/assets';

import { BrandLogo } from './BrandLogo';
import headerStyle from './Header.module.scss';

const SignupButton = dynamic(() => import('./SignupButton'), {
  ssr: false,
});

interface Props {
  stickyHeader?: boolean;
  assetsData?: LocalAssets;
}

function getAuthenticatePopup(assetsData?: LocalAssets) {
  if (!assetsData) return null;
  const header = parse(assetsData.header);
  if (!Array.isArray(header)) return null;
  const signinPopup = header.find((item) => item.props?.id === 'sbr');
  if (!signinPopup) return null;
  return React.cloneElement(signinPopup, { suppressHydrationWarning: true });
}

export const MarketingHeader: FC<Props> = ({ assetsData, stickyHeader }) => {
  const { i18n } = useTranslation();
  return (
    <header className="c-header p-header" data-testid="marketing-header">
      <div
        className={cn(
          'c-header__main',
          'sticky-shown',
          'with-transition',
          'sticky',
          {
            [headerStyle['always-shown']]: stickyHeader,
          }
        )}
      >
        <div className="c-header__wrapper u-wrapper">
          <div className="c-header__logo">
            <BrandLogo href={`/${i18n.language}`} />
          </div>

          <div className="tw:flex-1" />

          <SignupButton />
        </div>
      </div>
      {getAuthenticatePopup(assetsData)}
    </header>
  );
};
